module.exports = __webpack_public_path__ + "img/2117703618476510.9310343d.jpg";